module.exports = __webpack_public_path__ + "img/50.c7d74aa.jpg";